import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, compose, applyMiddleware } from 'redux';
import { autoRehydrate, persistStore } from 'redux-persist';
import localForage from 'localforage';
import Logger from 'redux-logger';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import 'react-modal-video/scss/modal-video.scss';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import reducers, { initialState } from './store/reducers';
import './index.css';

// add redux middlewares here
const middlewares = [];
if (process.env.NODE_ENV === 'development') {
  // Redux will log all changes into the web-dev console if we're running in dev mode
  middlewares.push(Logger);
}


// create the redux store
const store = createStore(
  reducers, initialState,
  compose(
    autoRehydrate(),
    applyMiddleware(...middlewares),
  ),
);

// this is the setup of our redux store
const configureStore = () => (
  new Promise((resolve, reject) => {
    try {
      persistStore(store, {
        storage: localForage,
      }, () => {
        store.subscribe(async () => {
          /**
           * add functions here to run every time any redux action is dispatched
           * we can get our current redux state (after the action has occured) by using:
           * const storeState = store.getState();
          */
        });
        resolve(store);
      });
    } catch (err) {
      reject(err);
    }
  })
);

// start the application
const init = async () => {
  const configuredStore = await configureStore();
  ReactDOM.render(
    <Provider store={configuredStore}>
      <App />
    </Provider>,
    document.getElementById('root'),
  );
};

init();
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js